import { Component, OnInit, Input } from '@angular/core';
import { VehicleSaleDisposal } from '../../model/staterequirements.model';

@Component({
  selector: 'app-state-requirement-personalproperty1',
  templateUrl: './state-requirement-personalproperty1.component.html',
  styleUrls: ['./state-requirement-personalproperty1.component.css']
})
export class StateRequirementPersonalproperty1Component implements OnInit {
  public role: string;
  public showFlag: boolean = false;
  private _personalPropertyEffects1: VehicleSaleDisposal;
  public parClicked: any;
  public agentClicked: any;
  public get personalPropertyEffects1(): VehicleSaleDisposal {
    return this._personalPropertyEffects1;
  }
  @Input()
  public set personalPropertyEffects1(value: VehicleSaleDisposal) {
    if (typeof value !== 'undefined' && value !== null) {
      this._personalPropertyEffects1 = value;
    } else {
      this._personalPropertyEffects1 = new VehicleSaleDisposal();
    }
  }
  constructor() {
    this._personalPropertyEffects1 = new VehicleSaleDisposal();
  }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if (this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked ==="false" && this.parClicked === "false")) {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag =  true;
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
    }
    else {
      this.showFlag = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/state-requirement-personalproperty1/state-requirement-personalproperty1.component.ts